import { render, staticRenderFns } from "./inspecao-item.vue?vue&type=template&id=b5dd4c24&scoped=true"
import script from "./inspecao-item.vue?vue&type=script&lang=js"
export * from "./inspecao-item.vue?vue&type=script&lang=js"
import style0 from "./inspecao-item.vue?vue&type=style&index=0&id=b5dd4c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dd4c24",
  null
  
)

export default component.exports